module.exports = __webpack_public_path__ + "img/blank_avatar.d66c8dc3.jpg";